export const TOGGLE_LOGIN_SEAMLESS_PRNT_MODAL = 'TOGGLE_LOGIN_SEAMLESS_PRNT_MODAL';
export const TOGGLE_PRNTR_SETUP_INSTRCTNS = 'TOGGLE_PRNTR_SETUP_INSTRCTNS';
export const TOGGLE_SEAMLESS_PRNTNG = 'TOGGLE_SEAMLESS_PRNTNG';
export const CHG_PRNT_INSTRCTNS_STAGE = 'CHG_PRNT_INSTRCTNS_STAGE';
export const UPDATE_FAULTY_PRNTR_INFO = 'UPDATE_FAULTY_PRNTR_INFO';
